import moment from 'moment';
import 'moment/locale/nb';

import {updateObject} from 'utils/reducerUtils';

const addMomentsToTestResult = (testResult) => {
	let {createdAt, distributedAt, usedAt, completedAt, isUsed} = testResult;

	createdAt = moment(createdAt);

	if (distributedAt) {
		distributedAt = moment(distributedAt).locale('nb');
	}

	if (isUsed && usedAt) {
		usedAt = moment(usedAt).locale('nb');
	}

	if (completedAt) {
		completedAt = moment(completedAt).locale('nb');
	}

	return updateObject(testResult, {
		createdAt,
		distributedAt,
		usedAt,
		completedAt,
	});
};

export default function addMomentsToTestResults(testResults) {
	return testResults.map(addMomentsToTestResult);
}
